import type { schemas } from '@gonfalon/openapi/types';
import type { ResourceSpecifier } from '@gonfalon/resource-specifiers/ast';
// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import { z } from 'zod';
export type Access = schemas['Access'];

type AccessAllowedReason = schemas['AccessAllowedReason'];
type AccessDeniedReason = schemas['AccessDeniedReason'];
export type AccessCheckResponse = schemas['AccessCheckResult'];
export type AccessReason = AccessAllowedReason | AccessDeniedReason;

export type AccessAllowed = schemas['AccessAllowedRep'];
export type AccessDenied = schemas['AccessDenied'];

export type AccessCheck =
  | Readonly<{ isAllowed: true; isLoading?: boolean }>
  | Readonly<{
      isAllowed: false;
      isLoading?: boolean;
      appliedRoleName?: string;
      customMessage?: string;
      reason?: AccessReason;
    }>;

export type EnvironmentChangeConfirmation = {
  isConfirmationRequired: boolean;
  isCommentRequired: boolean;
  isVerificationRequired: boolean;
};

export type CustomRole = schemas['CustomRole'];
export enum RoleResourceCategory {
  PROJECT = 'project',
  ORGANIZATION = 'organization',
  ANY = 'any',
}
export type Statement = schemas['Statement'];
export type Member = schemas['Member'];
export type Team = schemas['Team'];

export type { RoleName } from '@gonfalon/openapi/types';

export type RolePresetsBundle = schemas['RolePresetsBundle'];
export type RoleTemplate = schemas['RoleTemplate'];
export type AccessToken = schemas['Token'];

export type RoleMenuOption = {
  type: 'inline' | 'organization' | 'base';
  id: string;
  name: string;
  description?: string | undefined;
};

export enum RoleAttributeFormKind {
  RESOURCE = 'resource',
  TAG = 'tag',
  VIEW = 'view',
}

export const RoleAttributesSchema = z.array(
  z.object({
    attribute: z.string(),
    type: z.custom<ResourceSpecifier['type']>(),
    resources: z.array(z.string()),
    attributeKind: z.nativeEnum(RoleAttributeFormKind),
  }),
);
export type RoleAttributesFormValues = z.infer<typeof RoleAttributesSchema>;

export type Project = schemas['Project'];
export type Environment = schemas['Environment'];
export type Application = schemas['ApplicationRep'];
export type RoleAttributeMap = schemas['RoleAttributeMap'];
